import LoadingButton from '@mui/lab/LoadingButton';
import { TextField } from '@mui/material';
import styled from 'styled-components';
import colors from '@/styles/colors';

export const StyledContainer = styled.section``;

export const StyledButton = styled(LoadingButton)`
  &.Mui-disabled {
    pointer-events: all;
    cursor: not-allowed;
    background: ${colors.dark};
  }
`;

export const StyledTextField = styled(TextField)`
  & label,
  .Mui-focused {
    color: ${colors.light};
  }
  & fieldset {
    border-color: ${(props) => {
      if (props?.error) {
        return '#d32f2f';
      }
      if (!props?.error && props?.value) {
        return colors.success;
      }
      return colors.dark;
    }}!important;
  }
  &:hover fieldset {
    border-color: ${(props) => {
      if (props?.error) {
        return '#d32f2f';
      }
      if (!props?.error && props?.value) {
        return colors.success;
      }
      return colors.lighter;
    }}!important;
  }
  & input,
  textarea {
    color: ${colors.lighter}!important;
  }
  & .Mui-error {
    color: #d32f2f !important;
  }
`;

export const StyledConnectContainer = styled.div.attrs({
  className: 'flex justify-evenly items-center p-2',
})`
  @media (max-width: 576px) {
    flex-wrap: wrap;
  }
`;
